module.exports = __webpack_public_path__ + "media/images/Crown-abf34d2e.svg";